import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import { tryToRequestToRegisterPartner } from '../../../store/brokers/admin/partners/partnersSlice';
import SuccessRegisterModal from './modals/SuccessRegisterModal';
import Button from '../../../shared/button';
import Input from '../../../shared/input';
import Error from '../../../shared/error';
import LayoutRegister from './layout/LayoutRegister';


const Register = () => {
    const { id } = useParams();
    const [showRegisterModal, setShowRegisterModal] = useState<boolean>(false)
    const [createError, setCreateError] = useState<string>()
    const [loading, setLoading] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>();
    const [data, setData] = useState<any>();
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    const onGoToLogin = () => {
        navigate('/login')
        setShowRegisterModal(false)
    }

    const onChangeInput = (e: any, type?: string) => {
        if (type) {
            setData((prevData: any) => ({
                ...prevData || {},
                [type]: e
            }))
        }
    }

    const onValidate = () => {
        let errorsData: any
        /* eslint-disable-next-line */
        const regexPassword: any = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
        /* eslint-disable-next-line */
        const regexUsername: any = /^[^@\s]+$/
        /* eslint-disable-next-line */
        const regexEmail: any = /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!data?.username) {
            errorsData = {
                ...errorsData || {},
                username: 'Username is required'
            }
        } else if (data?.username && !regexUsername.test(data?.username)) {
            errorsData = {
                ...errorsData || {},
                username: 'Username should not include spaces or @ symbol'
            }
        }
        if (!data?.name) {
            errorsData = {
                ...errorsData || {},
                name: 'Primary Contact Name is required'
            }
        }
        if (!data?.email) {
            errorsData = {
                ...errorsData || {},
                email: 'Primary Contact Email is required'
            }
        } else if (data?.email && !regexEmail.test(data?.email)) {
            errorsData = {
                ...errorsData || {},
                email: 'Please write a valid email'
            }
        }
        if (!data?.password) {
            errorsData = {
                ...errorsData || {},
                password: 'Password is required'
            }
        } else if (data?.password && !regexPassword.test(data?.password)) {
            errorsData = {
                ...errorsData || {},
                password: 'Password should be at least 8 characters long, and must contain at least 1 number, 1 lower case, 1 upper case and 1 special character(@$!%*?&) and spaces are not allowed'
            }
        }
        if (!data?.confirmPassword) {
            errorsData = {
                ...errorsData || {},
                confirmPassword: 'Repeat Password is required'
            }
        } else if (data?.confirmPassword && data?.password !== data?.confirmPassword) {
            errorsData = {
                ...errorsData || {},
                confirmPassword: 'Repeat Password does not match'
            }
        }
        if (!data?.country) {
            errorsData = {
                ...errorsData || {},
                country: 'Country is required'
            }
        }
        if (!data?.companyName) {
            errorsData = {
                ...errorsData || {},
                companyName: 'Company Name is required'
            }
        }
        if (!data?.companyRegistrationNumber) {
            errorsData = {
                ...errorsData || {},
                companyRegistrationNumber: 'Company Registration Number is required'
            }
        }
        if (errorsData) {
            setCreateError(undefined)
            setErrors(errorsData)
            return false
        } else {
            setCreateError(undefined)
            setErrors(undefined)
            return true;
        }
    };

    const onRequestToRegisterUser = async () => {
        setLoading(true)
        if (id && onValidate()) {
            const payload = {
                ...data,
                token: id
            }
            try {
                await dispatch(tryToRequestToRegisterPartner(payload)).unwrap();
                navigate('/login');
                setData(undefined)
                setErrors(undefined)
                setCreateError(undefined)
                setShowRegisterModal(true)
                return true
            } catch (error) {
                setCreateError(`${error}`)
                return false
            }
        }
        setLoading(false)
    }

    return (
        <LayoutRegister>
            <div className='min-w-[100%] min-h-full flex flex-col justify-between items-start'>
                <div className="min-w-[95%] m-auto">
                    <h1 className="font-dm_sans_bold text-4xl">Please fill your details</h1>
                    {id ?
                        <>
                            {createError && <Error text={createError} />}
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-3 mt-5 mb-3'>
                                <Input
                                    containerStyle='mb-1'
                                    placeholder='Primary Contact Email'
                                    dataQa={'create-partner-email'}
                                    showValue={true}
                                    inputUniqueName='email'
                                    onChangeInput={onChangeInput}
                                    inputValue={data?.email}
                                    error={errors?.email}
                                />
                                <Input
                                    containerStyle='mb-1'
                                    placeholder='Username'
                                    dataQa={'create-partner-username'}
                                    inputUniqueName='username'
                                    onChangeInput={onChangeInput}
                                    showValue={true}
                                    inputValue={data?.username}
                                    error={errors?.username}
                                />
                                <Input
                                    placeholder='Set a password'
                                    dataQa={'create-partner-password'}
                                    containerStyle='mb-2'
                                    type={'password'}
                                    showValue={true}
                                    onChangeInput={onChangeInput}
                                    inputUniqueName={'password'}
                                    inputValue={data?.password}
                                    error={errors?.password}
                                />
                                <Input
                                    placeholder='Repeat Password'
                                    dataQa={'create-partner-repeat-password'}
                                    containerStyle='mb-2'
                                    type={'password'}
                                    showValue={true}
                                    inputUniqueName='confirmPassword'
                                    onChangeInput={onChangeInput}
                                    inputValue={data?.confirmPassword}
                                    error={errors?.confirmPassword}
                                />
                            </div>
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-3 mt-5 mb-3'>
                                <Input
                                    containerStyle='mb-1'
                                    placeholder={'Primary Contact Name'}
                                    dataQa={'create-directors-name'}
                                    inputValue={data?.name}
                                    inputUniqueName='name'
                                    onChangeInput={onChangeInput}
                                    showValue={true}
                                    error={errors?.name}
                                />
                                <Input
                                    placeholder='Country'
                                    dataQa={'create-partner-country'}
                                    containerStyle='mb-1'
                                    inputUniqueName='country'
                                    showValue={true}
                                    onChangeInput={onChangeInput}
                                    inputValue={data?.country}
                                    error={errors?.country}
                                />
                                <Input
                                    placeholder='Company Registration Number'
                                    dataQa={'company-registation-number'}
                                    containerStyle='mb-1'
                                    inputUniqueName='companyRegistrationNumber'
                                    showValue={true}
                                    onChangeInput={onChangeInput}
                                    inputValue={data?.companyRegistrationNumber}
                                    error={errors?.companyRegistrationNumber}
                                />
                                <Input
                                    placeholder='Company Name'
                                    dataQa={'create-partner-name'}
                                    containerStyle='mb-1'
                                    inputUniqueName='companyName'
                                    showValue={true}
                                    onChangeInput={onChangeInput}
                                    inputValue={data?.companyName}
                                    error={errors?.companyName}
                                />
                            </div>
                            <div className='flex flex-row justify-center mt-5 mb-10'>
                                <Button
                                    label={'Register'}
                                    className={`${!loading ? 'btn-primary-rounded-less' : 'btn-primary-rounded-less-disable'} min-w-[250px] !shadow-none !rounded-full`}
                                    onClickButton={onRequestToRegisterUser}
                                />
                            </div>
                            <SuccessRegisterModal
                                openModal={showRegisterModal}
                                handleCloseModal={onGoToLogin}
                            />
                        </>
                        : <div className='my-10 bg-[#e4ede657] p-2 !rounded'>
                            <p className='text-primary-default'>You need an invite to register please contact our team or check you email for invitation!</p>
                        </div>
                    }
                    <div className="font-dm_sans_regular text-center flex flex-col items-center mt-8">
                        <Button
                            label={'I have an account.'}
                            className={'btn-primary-text !font-normal'}
                            onClickButton={onGoToLogin}
                        />
                    </div>
                </div>
            </div>
        </LayoutRegister>
    )
}

export default Register;